module.exports = __webpack_public_path__ + "img/4.f5c2f294.png";